import type { MonospaceInvite, MonospaceProjectMember } from '#layers/data-model';
import { RStoreSchema } from '#imports';
import { deleteMembers } from '~/rstore/utils/collections/members';

export const ProjectMember = RStoreSchema.withItemType<MonospaceProjectMember>().defineCollection({
	name: 'MonospaceSystemUser',
	meta: {
		defaultFields: ['id', 'email', 'fullName', 'isService'],
		useProjectSlug: true,
		fetchOnCreate: true,
		endpoint: {
			many: 'members',
		},
	},
	hooks: {
		async delete({ key }) {
			await deleteMembers([key as string]);
		},
		async deleteMany({ keys }) {
			await deleteMembers(keys as string[]);
		},
	},
});

export const ProjectInvite = RStoreSchema.withItemType<MonospaceInvite>().defineCollection({
	name: 'MonospaceProjectInvite',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: [
			'id',
			'email',
			'projectId',
			'projectRoles',
			'orgRoleId',
			'invitedById',
			'expiresAt',
			'createdAt',
		],
		useProjectSlug: true,
		endpoint: 'invites',
	},
});
